import cn from 'classnames';
import { Auth } from 'aws-amplify';

/* Styles */
import styles from 'styles/federated-login-button.module.scss';

/* Assets */
import Amazon from 'assets/images/SocialLogoAmazon.svg';
import Google from 'assets/images/SocialLogoGoogle.svg';
import UIOnline from 'assets/images/UIOnline.png';

/* i18n */
import { useIntl } from 'react-intl';

/* Analytics */
import { trackEvent } from 'lib/analytics';

const providersDict = {
  google: 'Google',
  amazon: 'LoginWithAmazon',
  uionline: 'UIOnline'
}

const imagesDict = {
  google: Google,
  amazon: Amazon,
  uionline: UIOnline
}

const translationsDict = {
  google: 'federatedGoogle',
  amazon: 'federatedAmazon',
  uionline: 'federatedUIOnline'
}

const eventTrackingDict = {
  google: 'GOOGLE',
  amazon: 'AMAZON',
  uionline: "UIONLINE"
}

const FederatedLoginButton = ({type = 'google'}) => {
  
  const intl = useIntl();

  const handleClick = () => {
    trackEvent(`LOGIN_${eventTrackingDict[type]}`);
    Auth.federatedSignIn({provider: providersDict[type]});
  }

  return(
    <button
      className={cn({
        [styles.federatedLoginButton]: true,
        [styles.googleButton]: type === 'google',
        [styles.amazonButton]: type === 'amazon',
        [styles.uiOnlineButton]: type === 'uionline'
      })}
      onClick={handleClick}
    >
      <img
        alt="Social Network Logo"
        className={cn({
          [styles.socialLogo]: true,
          [styles.googleLogo]: type === 'google',
          [styles.amazonLogo]: type === 'amazon',
          [styles.uiOnlineLogo]: type === 'uionline'
        })}
        src={imagesDict[type]}
      />
        {type !== 'uionline' ? intl.formatMessage({id: `forms.signIn.${translationsDict[type]}`, description:'string'}) : null}
    </button>
  )
}

export default FederatedLoginButton;